import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ecdcf4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-window"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Load Packages From Robot", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Use this menu to load any running packages on your robot onto Miros. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Input any extra commands needed before using ROS on your robot below. These can often be found at the bottom of the file ~/.bashrc. ", -1))
const _hoisted_5 = {
  key: 1,
  class: "popup-window"
}
const _hoisted_6 = { class: "progress-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _withDirectives(_createElementVNode("textarea", {
            name: "",
            id: "",
            cols: "20",
            rows: "12",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.commands) = $event)),
            spellcheck: "false"
          }, null, 512), [
            [_vModelText, _ctx.commands]
          ]),
          _createElementVNode("button", {
            class: "rectangle-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onLoadPressed()))
          }, "Load")
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.loadingText), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "progress-bar",
              style: _normalizeStyle({ width: `${_ctx.loadingValue}%` })
            }, null, 4)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.visible || _ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "dialog-bg center",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exit()))
        }))
      : _createCommentVNode("", true)
  ], 64))
}